export const FISHYMAP_SIGNAL_PATCHED_EVENT = "fishymap:signal-patched";
export const FISHYMAP_PROGRAMMATIC_SIGNAL_PATCH_DEPTH_PROPERTY =
  "__fishymapProgrammaticSignalPatchDepth";

function cloneJson(value) {
  return JSON.parse(JSON.stringify(value));
}

function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

export function runWithProgrammaticSignalPatch(shell, callback) {
  if (!shell || typeof shell !== "object" || typeof callback !== "function") {
    return undefined;
  }
  const previousDepth = Number.isSafeInteger(
    shell[FISHYMAP_PROGRAMMATIC_SIGNAL_PATCH_DEPTH_PROPERTY],
  )
    ? Math.max(0, shell[FISHYMAP_PROGRAMMATIC_SIGNAL_PATCH_DEPTH_PROPERTY])
    : 0;
  shell[FISHYMAP_PROGRAMMATIC_SIGNAL_PATCH_DEPTH_PROPERTY] = previousDepth + 1;
  try {
    return callback();
  } finally {
    if (previousDepth > 0) {
      shell[FISHYMAP_PROGRAMMATIC_SIGNAL_PATCH_DEPTH_PROPERTY] = previousDepth;
    } else {
      delete shell[FISHYMAP_PROGRAMMATIC_SIGNAL_PATCH_DEPTH_PROPERTY];
    }
  }
}

export function combineSignalPatches(...patches) {
  const next = {};
  for (const patch of patches) {
    if (!isPlainObject(patch)) {
      continue;
    }
    Object.assign(next, cloneJson(patch));
  }
  return next;
}
